import styled from 'styled-components'

const Wrapper = styled.div<{ $show: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  transition: 0.3s;
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  visibility: hidden;
  padding: 16px 16px;
  ${({ $show }) =>
    $show
      ? `
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0%, 0);
    `
      : ''}
`

export { Wrapper }
